<template>
  <div>
    <span>
      {{ item.roleName }}
    </span>
    <div
      v-if="item.provider"
      :class="$style.tooltipContainer"
    >
      <IconTooltip>
        You don't have permission to edit this administrator.
        This administrator can only be edited in the Multi-Tenant Portal.
      </IconTooltip>
    </div>
  </div>
</template>

<script>
import IconTooltip from 'components/Tooltip/IconTooltip.vue';

export default {
  name: 'AdminRole',

  components: {
    IconTooltip,
  },

  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style module>
.tooltipContainer { display: inline-block; }
</style>
